var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFallbackTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 500,
    viewBox: "0 0 300 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4318_6200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 500,
    rx: 16,
    fill: "url(#paint0_linear_4318_6200)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    r: 4,
    fill: "#A2C166"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 62,
    r: 4,
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 190,
    r: 4,
    fill: "#6CBFBF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 62,
    r: 4,
    fill: "#9C6EBA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: -4,
    r: 4,
    fill: "#EEE850"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 137 44)",
    fill: "#EEE850"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 31 399)",
    fill: "#A2C166"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 212 287)",
    fill: "url(#paint1_linear_4318_6200)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 35 112)",
    fill: "url(#paint2_linear_4318_6200)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 39 247)",
    fill: "url(#paint3_linear_4318_6200)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 292 337)",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 68 447)",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 272 443)",
    fill: "#6CBFBF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 226 439)",
    fill: "#9C6EBA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_4318_6200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 258 403)",
    fill: "#EEE850"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 250,
    r: 130,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.297 229.916H123.05",
    stroke: "#515151",
    strokeWidth: 7.1358,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.641 229.916H162.394",
    stroke: "#515151",
    strokeWidth: 7.1358,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.784 229.916H199.537",
    stroke: "#515151",
    strokeWidth: 7.1358,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3791 102.027C93.4234 102.027 91.0273 104.424 91.0273 107.379L91.0273 216.549C93.354 217.172 95.4991 218.398 97.2318 220.131C99.8269 222.726 101.285 226.245 101.285 229.915C101.285 233.585 99.8269 237.105 97.2318 239.7C95.4991 241.433 93.354 242.658 91.0273 243.282L91.0273 393.966C91.0273 396.922 93.4234 399.318 96.3791 399.318H128.972V395.75V393.508C128.972 391.045 130.969 389.048 133.432 389.048H166.025C168.488 389.048 170.485 391.045 170.485 393.508V395.75V399.318H203.078C206.033 399.318 208.429 396.922 208.429 393.966V250.673L208.429 243.286C206.098 242.664 203.949 241.437 202.213 239.701C199.618 237.106 198.16 233.586 198.16 229.916C198.16 226.246 199.618 222.727 202.213 220.132C203.949 218.396 206.098 217.169 208.429 216.547V107.379C208.429 104.424 206.033 102.027 203.078 102.027L96.3791 102.027ZM91.0273 235.933L91.0273 235.846C89.9855 236.474 88.7647 236.835 87.4594 236.835C87.4131 236.835 87.3668 236.835 87.3207 236.834H83.8915L83.8915 393.966C83.8915 400.863 89.4824 406.454 96.3791 406.454H135.879V395.966H163.554V406.454H203.078C209.974 406.454 215.565 400.863 215.565 393.966V250.673L215.565 236.834H212.125C212.082 236.835 212.04 236.835 211.997 236.835C210.692 236.835 209.471 236.474 208.429 235.845V235.941C207.929 235.645 207.464 235.286 207.046 234.868C205.733 233.554 204.995 231.773 204.995 229.916C204.995 228.059 205.733 226.278 207.046 224.965C207.464 224.547 207.929 224.187 208.429 223.891V223.987C209.468 223.361 210.685 223 211.985 222.997V222.996H215.565L215.565 107.379C215.565 100.483 209.974 94.8917 203.078 94.8917L96.3791 94.8917C89.4824 94.8917 83.8915 100.483 83.8915 107.379L83.8915 222.996H87.4472L87.4472 222.998L87.4594 222.998C88.7647 222.998 89.9855 223.359 91.0273 223.987V223.897C91.5228 224.192 91.984 224.549 92.3986 224.964C93.7117 226.277 94.4495 228.058 94.4495 229.915C94.4495 231.772 93.7118 233.553 92.3986 234.867C91.984 235.281 91.5228 235.638 91.0273 235.933Z",
    fill: "#515151"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 299,
    height: 499,
    rx: 15.5,
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4318_6200",
    x: 2,
    y: -8,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.666667 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4318_6200",
    x: 263,
    y: 54,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.32549 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4318_6200",
    x: 47,
    y: 182,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4318_6200",
    x: 55,
    y: 54,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.431373 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4318_6200",
    x: 229,
    y: -12,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_4318_6200",
    x: 133,
    y: 32,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_4318_6200",
    x: 27,
    y: 387,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.666667 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_4318_6200",
    x: 208,
    y: 275,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.666667 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_4318_6200",
    x: 31,
    y: 100,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.666667 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_4318_6200",
    x: 35,
    y: 235,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.666667 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_4318_6200",
    x: 288,
    y: 325,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.32549 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_4318_6200",
    x: 64,
    y: 435,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.32549 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_4318_6200",
    x: 268,
    y: 431,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_4318_6200",
    x: 222,
    y: 427,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.431373 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_4318_6200",
    x: 254,
    y: 391,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_6200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4318_6200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4318_6200",
    x1: 0,
    y1: 0,
    x2: 291,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4318_6200",
    x1: 3.73333,
    y1: -8.28571,
    x2: 14.4036,
    y2: -4.04149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8C7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4318_6200",
    x1: 3.73333,
    y1: -8.28571,
    x2: 14.4036,
    y2: -4.04149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8C7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4318_6200",
    x1: 3.73333,
    y1: -8.28571,
    x2: 14.4036,
    y2: -4.04149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8C7B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4318_6200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 500,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackTicket);
export default __webpack_public_path__ + "static/media/fallbackTicket.6ffa61a65aa6c4f08476cea9ac4ae2bc.svg";
export { ForwardRef as ReactComponent };